import React, { useCallback, useContext, useState } from 'react';
import { PapiUser } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import LoadingIndicator from '@wix/da-shared-react/pkg/LoadingIndicator';
import Zone, { ZoneGroup } from '../../Layout/Zone';
import { ZoneType } from '../../../../types/layout';
import { ModuleType } from '../../../../types/modules';
import TiersBox from '../../UserWidgets/Tiers/ProductBox';
import SubscriptionCenterBox from '../../UserWidgets/SubscriptionCenter';
import SubscriptionTipsBox from '../../UserWidgets/SubscriptionTips';
import TierContent from '../../UserWidgets/TierContent';
import SubscriptionsCoreOnlyBlock from './SubscriptionsCoreOnlyBlock';
import SubscriptionsVisitorEmptyState from './SubscriptionsVisitorEmptyState/SubscriptionsVisitorEmptyState';
import TierPublishSuccessModal from './TierPublishSuccessModal';
import s from './SubscriptionsSection.scss';

export interface Props {
  isSectionLoading: boolean;
  isOwner: boolean;
  hasTiers: boolean;
  hasCore: boolean;
  profileOwnerUser: PapiUser;
  createTipJarTier: () => void;
}

const SubscriptionsSection: React.FC<Props> = ({
  isOwner,
  hasTiers,
  hasCore,
  profileOwnerUser,
  isSectionLoading,
  createTipJarTier,
}) => {
  const isMobile = useContext(MobileContext);

  const [showSuccessModal, setShowSuccessModal] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return !!new URLSearchParams(window.location.search).get(
      'tier-publish-success'
    );
  });

  const dismissSuccessModal = useCallback(() => setShowSuccessModal(false), []);

  if (isSectionLoading) {
    return <LoadingIndicator />;
  }
  if (!hasTiers) {
    if (isOwner) {
      return <SubscriptionsCoreOnlyBlock className={s['core-only-block']} />;
    } else {
      return (
        <SubscriptionsVisitorEmptyState profileOwnerUser={profileOwnerUser} />
      );
    }
  }

  return (
    <div className={s['root']}>
      {showSuccessModal && (
        <TierPublishSuccessModal onClose={dismissSuccessModal} />
      )}
      <ZoneGroup>
        {isOwner && (
          <Zone
            className={s['top-zone']}
            locked={true}
            type={ZoneType.MID_RIGHT}
            mapModuleTypeToWidgetComponent={
              isMobile
                ? {
                    [ModuleType.SUBSCRIPTION_CENTER]: SubscriptionCenterBox,
                  }
                : {
                    [ModuleType.SUBSCRIPTION_CENTER]: SubscriptionCenterBox,
                    [ModuleType.SUBSCRIPTION_TIPS]: SubscriptionTipsBox,
                  }
            }
          />
        )}
        <Zone
          locked={true}
          type={ZoneType.MID_RIGHT}
          mapModuleTypeToWidgetComponent={{
            [ModuleType.TIERS]: TiersBox,
            [ModuleType.TIER_CONTENT]: TierContent,
          }}
        />
      </ZoneGroup>
    </div>
  );
};
SubscriptionsSection.displayName = 'SubscriptionsSection';

export default SubscriptionsSection;
